import types from 'actions/types'
import {combineReducers} from 'redux'

const ready = (state = false, action) => {
  switch (action.type) {
    case types.UI_READY:
      return true
    case types.LOGIN_SUCCESS:
      return false
    default:
      return state
  }
}

export default combineReducers({
  ready,
})
